<div class="bary-table-list mt-3 table-responsive">
  <table mdbTable [hover]="false" [small]="true">
    <thead>
      <tr jhiSort [(predicate)]="pagination.predicate" [(ascending)]="pagination.reverse" (sortChange)="transition()">
        <th jhiSortBy="type">
          <span jhiTranslate="headband.type">Type</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="content">
          <span jhiTranslate="headband.content">message</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="startDate">
          <span jhiTranslate="headband.startDate">Date de début</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="endDate">
          <span jhiTranslate="headband.endDate">Date de début</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th>
          <span jhiTranslate="headband.actions">Actions</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let message of messages; trackBy: trackId">
        <td>
          <span>{{ message.type }}</span>
        </td>
        <td>
          <span [mdbTooltip]="message.content!">{{ message.content! | customslice: 10 }}</span>
        </td>
        <td>
          <span>{{ message.startDate | date }}</span>
        </td>
        <td>
          <span>{{ message.endDate | date }}</span>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <a type="button" (click)="addToHeadband(message)" [mdbTooltip]="'entity.action.edit' | translate" mdbBtn [floating]="true" [outline]="true" size="sm" color="primary">
              <mdb-icon fas icon="pencil-alt"></mdb-icon>
            </a>
            <a type="button" (click)="deleteHeadband(message)" [mdbTooltip]="'entity.action.delete' | translate" mdbBtn [floating]="true" size="sm" color="primary">
              <mdb-icon fas icon="times"></mdb-icon>
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
